import { triggerEvent, addClass, removeClass } from './utils';

export default class Donation {
  constructor(id, currency) {
    this.id = id;
    this.currency = currency;

    this.questionWrapper = document.querySelector(`#id_${this.id}`);
    this.donationField = this.questionWrapper.querySelector('input[id*="_donation"]');
    this.donationSpecial = this.questionWrapper.querySelector('.donation-special');
    this.suggestions = this.questionWrapper.querySelectorAll('.js-donation-suggestion');
    this.donationFieldOverlay = this.questionWrapper.querySelector('.js-donation-overlay');

    this.onSuggestionChange = this.onSuggestionChange.bind(this);
    this.onDonationFieldChange = this.onDonationFieldChange.bind(this);
    this.onOverlayClick = this.onOverlayClick.bind(this);
  }

  initDonation() {
    this.suggestions.forEach(field => {
      field.addEventListener('change', this.onSuggestionChange);
    });

    this.donationField.addEventListener('change', this.onDonationFieldChange);
    this.donationField.addEventListener('keyup', this.onDonationFieldChange);

    if (this.donationFieldOverlay) {
      this.donationFieldOverlay.addEventListener('click', this.onOverlayClick);
      this.donationFieldOverlay.addEventListener('keypress', e => { if (e.keyCode === 32) e.target.click(); });
    }
  }

  onSuggestionChange({ target }) {
    this.openOverlay();
    this.donationField.value = target.value.replace(/[^.0-9]+/g, '');
    // global.JotForm.paymentTotal = this.value;
    triggerEvent(this.donationField, 'change');
  }

  onDonationFieldChange({ target }) {
    const { value } = target;

    this.suggestions.forEach(f => {
      const field = f;
      field.checked = field.value === value;
    });
  }

  onOverlayClick() {
    this.closeOverlay();
    this.resetDonationField();
    this.donationField.focus();
  }

  resetDonationField() {
    this.donationField.value = '';
    triggerEvent(this.donationField, 'change');
  }

  openDonationField() {
    addClass(this.donationSpecial, 'donation-special--active');
  }

  closeDonationField() {
    removeClass(this.donationSpecial, 'donation-special--active');
  }

  openOverlay() {
    removeClass(this.donationSpecial, 'donation-special--active');
  }

  closeOverlay() {
    addClass(this.donationSpecial, 'donation-special--active');
  }
}
